@if (label()) {
  <label class="font-normal-semibold">
    {{ label() }}
  </label>
}

<div class="input-wrapper" [ngClass]="size()" [class.with-color-box]="!fullyColored()">
  <input
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [class.light-text]="isDarkColor()"
    [class.disabled]="disabledColorPicker()"
    [formControl]="formControl"
    [style.backgroundColor]="fullyColored() ? formControl.value : 'transparent'"
    (click)="toggleColorPicker()" />

  <div class="color-preview" (click)="toggleColorPicker()">
    <div [style.backgroundColor]="formControl.value"></div>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="openColorPicker()"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="overlayPositions"
    (overlayOutsideClick)="toggleColorPicker()">
    <div [class.has-swatches]="swatches().length" class="color-wrapper">
      <color-sketch
        [color]="formControl.value"
        [presetColors]="swatches()"
        (onChange)="onColorChange($event.color)" />
    </div>
  </ng-template>
</div>
